import UserProfilePopup from "./UserProfilePopup";

export default UserProfilePopup;
